// extracted by mini-css-extract-plugin
module.exports = {"page":"Contacts_page__28x14"};